export const TRANSLATIONS_PT_GENERATION = {
  "generate.title": "Gerar documento",
  "generate.subtitle": "Resumo executivo a partir das fontes selecionadas",
  "generate.action": "Gerar",
  "generate.generating": "Gerando...",
  "generate.sources.title": "Fontes",
  "generate.sources.clear": "Limpar selecao",
  "generate.sources.loading": "Carregando documentos...",
  "generate.language": "Idioma",
  "generate.expertRole": "Especialista",
  "generate.expertRole.general": "Geral",
  "generate.message.label": "Mensagem para o resumo (opcional)",
  "generate.message.placeholder": "Ex.: foque em riscos e próximos passos…",
  "generate.message.counter": "{count}/{max}",
  "generate.validation.selectSource": "Selecione pelo menos uma fonte.",
  "generate.toast.success": "Rascunho gerado.",
  "generate.toast.enqueued": "Geração na fila. Estará pronta em alguns minutos; avisaremos você.",
  "generate.errors.documents": "Nao foi possivel carregar os documentos.",
  "generate.errors.forbidden": "Seu plano nao permite gerar documentos ou a cota foi atingida.",
  "generate.errors.insufficientEvidence": "A evidencia selecionada nao e suficiente.",
  "generate.errors.generic": "Nao foi possivel gerar o documento.",
  "generate.errors.download": "Nao foi possivel baixar o PDF.",
  "generate.picker.title": "Quais documentos você quer selecionar para gerar seu resumo?",
  "generate.picker.searchPlaceholder": "Buscar documentos…",
  "generate.picker.empty": "Nenhum documento encontrado.",
  "generate.picker.selected": "selecionados",
  "generate.picker.confirm": "Concluído",
  "generate.picker.open": "Selecionar documentos",
  "generate.sources.empty": "Nenhum documento selecionado ainda. Use “Selecionar documentos” para escolhê-los.",
  "generate.warnings.sourcesUnavailable": "Algumas fontes já não estão disponíveis e foram removidas. Consulte-as novamente se precisar.",
  "generate.preview.title": "Pre-visualizacao",
  "generate.preview.empty": "Selecione fontes e gere o rascunho.",
  "generate.download": "Baixar PDF",
  "generate.downloading": "Baixando...",
  "generate.mySummaries": "Documentos Gerados",
  "generate.history.title": "Documentos Gerados",
  "generate.history.subtitle": "Histórico de resumos executivos gerados",
  "generate.export.docx": "Baixar DOCX",
  "generate.export.draftWatermark": "O download incluirá a marca d'água RASCUNHO (documento não aprovado)",
  "generate.history.notify.ready": "Seu resumo executivo está pronto.",
  "generate.history.notify.failed": "Não foi possível gerar o resumo.",
  "generate.history.pagination.label": "Paginação",
  "generate.history.pagination.prev": "Anterior",
  "generate.history.pagination.next": "Próximo",
  "generate.history.unnamedDocument": "Documento",
  "generate.history.enqueuedBanner": "Seu resumo está sendo gerado em segundo plano. Avisaremos quando estiver pronto; você pode continuar trabalhando.",
  "generate.history.dismiss": "Fechar",
  "generate.history.new": "Novo resumo",
  "generate.history.col.files": "Arquivos",
  "generate.history.col.created": "Criado",
  "generate.history.col.status": "Estado",
  "generate.history.col.expert": "Especialista",
  "generate.history.expert.general": "Geral",
  "generate.history.col.actions": "Ações",
  "generate.history.status.downloaded": "Baixado",
  "generate.history.status.pending": "Pendente",
  "generate.history.status.processing": "Processando",
  "generate.history.status.completed": "Concluído",
  "generate.history.status.failed": "Falhou",
  "generate.history.action.download": "Baixar PDF",
  "generate.history.action.regenerate": "Regenerar",
  "generate.history.empty": "Você ainda não gerou resumos.",
  "generate.history.emptyCta": "Gerar meu primeiro resumo",
  "generate.history.loading": "Carregando resumos...",
  "generate.history.error": "Não foi possível carregar os resumos.",
  "generate.history.retry": "Tentar novamente",
  "generate.history.moreFiles": "+{count}",
  "generate.history.col.message": "Mensagem",
  "generate.history.noMessage": "—",
  "generate.lifecycle.tabs.label": "Filtrar por estado",
  "generate.lifecycle.tab.all": "Todos",
  "generate.lifecycle.tab.draft": "Rascunhos",
  "generate.lifecycle.tab.in_review": "Em revisão",
  "generate.lifecycle.tab.approved": "Aprovados",
  "generate.lifecycle.tab.rejected": "Rejeitados",
  "generate.lifecycle.tab.archived": "Arquivados",
  "generate.lifecycle.status.draft": "Rascunho",
  "generate.lifecycle.status.in_review": "Em revisão",
  "generate.lifecycle.status.approved": "Aprovado",
  "generate.lifecycle.status.rejected": "Rejeitado",
  "generate.lifecycle.status.archived": "Arquivado",
  "generate.lifecycle.col.version": "Versão",
  "generate.lifecycle.action.submit": "Enviar para revisão",
  "generate.lifecycle.action.approve": "Aprovar",
  "generate.lifecycle.action.reject": "Rejeitar",
  "generate.lifecycle.action.archive": "Arquivar",
  "generate.lifecycle.action.timeline": "Ver histórico de alterações",
  "generate.lifecycle.action.revise": "Corrigir e reenviar",
  "generate.lifecycle.action.unarchive": "Restaurar",
  "generate.lifecycle.confirm.title": "Confirmar ação",
  "generate.lifecycle.confirm.submit": "Enviar este resumo para revisão?",
  "generate.lifecycle.confirm.approve": "Aprovar este resumo? Ele será marcado como conteúdo revisado.",
  "generate.lifecycle.confirm.archive": "Arquivar este resumo? Ele deixará de estar ativo.",
  "generate.lifecycle.confirm.cancel": "Cancelar",
  "generate.lifecycle.confirm.accept": "Confirmar",
  "generate.lifecycle.reject.title": "Rejeitar resumo",
  "generate.lifecycle.reject.reasonLabel": "Motivo da rejeição (obrigatório)",
  "generate.lifecycle.reject.placeholder": "Explique por que este resumo está sendo rejeitado...",
  "generate.lifecycle.reject.confirm": "Rejeitar",
  "generate.lifecycle.confirm.revise": "Devolver este resumo para rascunho para corrigi-lo? Você poderá enviá-lo para revisão novamente.",
  "generate.lifecycle.confirm.unarchive": "Restaurar este resumo arquivado? Ele voltará para rascunho.",
  "generate.lifecycle.toast.submitted": "Resumo enviado para revisão.",
  "generate.lifecycle.toast.approved": "Resumo aprovado.",
  "generate.lifecycle.toast.rejected": "Resumo rejeitado.",
  "generate.lifecycle.toast.archived": "Resumo arquivado.",
  "generate.lifecycle.toast.revised": "Resumo devolvido para rascunho.",
  "generate.lifecycle.toast.unarchived": "Resumo restaurado para rascunho.",
  "generate.lifecycle.toast.error": "Não foi possível concluir a ação. Tente novamente.",
  "generate.detail.view": "Ver detalhe",
  "generate.detail.title": "Detalhe do resumo",
  "generate.detail.close": "Fechar",
  "generate.detail.empty": "Este resumo não tem conteúdo para exibir.",
  "generate.lifecycle.timeline.title": "Histórico de mudanças de estado",
  "generate.lifecycle.timeline.empty": "Nenhuma transição registrada.",
  "generate.lifecycle.timeline.error": "Não foi possível carregar o histórico de alterações.",
  "generate.lifecycle.timeline.close": "Fechar",
  "generate.lifecycle.generatedByAi": "Conteúdo gerado por IA: revise antes de usá-lo como documento oficial.",
  "generate.lifecycle.draftBadge": "RASCUNHO — não aprovado",
};
